import moment from 'moment'

import Api from 'Api'
import Store from '@/utils/Store'

export default class TokenRepository {

    static #tokenCacheTimeout = 10 // seconds

    static getUserTokens (ignoreCache = false) {
        let reload = ignoreCache
        if (!reload) {
            // Check for cache timeout
            let tmp = Store.state.tokens
            if (tmp.updated === null) {
                reload = true
            } else {
                let now = moment().utc()
                reload = Math.floor((now - tmp.updated) / 1000) > TokenRepository.#tokenCacheTimeout
            }
        }

        // Get token list
        if (!reload) {
            return new Promise((resolve) => { resolve(Store.state.tokens.list) })
        }

        // Reload tokens list
        return new Promise((resolve, reject) => {
            Api.getTokens()
                .then(resp => {
                    if (typeof resp.status !== 'number' || resp.status !== 200) {
                        reject('Invalid return status.')
                        return
                    }
                    if (typeof resp.data !== 'object' || !(resp.data instanceof Array)) {
                        reject('Invalid return data.')
                        return
                    }

                    Store.commit('tokens', resp.data)
                    resolve(Store.state.tokens.list)
                })
                .catch(err => {
                    reject('Invalid API response.')
                })
        })
    }

}